import { defineMessages } from "react-intl";

export default defineMessages({
  deactivateApp: {
    id: "73RU3R",
    defaultMessage:
      "Are you sure you want to disable this app? Your data will be kept until you reactivate the app. You will be still billed for the app.",
    description: "deactivate app",
  },
  deactivateNamedApp: {
    id: "w6Gau0",
    defaultMessage:
      "Are you sure you want to disable {name}? Your data will be kept until you reactivate the app. You will be still billed for the app.",
    description: "deactivate named app",
  },
  deactivateLocalApp: {
    id: "7O2EsY",
    defaultMessage:
      "Are you sure you want to disable this app? Your data will be kept until you reactivate the app.",
    description: "deactivate local app",
  },
  deactivateLocalNamedApp: {
    id: "Np7J92",
    defaultMessage:
      "Are you sure you want to disable {name}? Your data will be kept until you reactivate the app.",
    description: "deactivate local named app",
  },
});
